import { formataTelefone } from '../../../../../utils';

type State = {
	nome: string;
	email: string;
	telefone: string;
};

type Action =
	| { type: 'SET_FIELD_VALUE'; field: string; payload: string }
	| { type: 'REPLACE_STATE'; payload: State };

export const shopkeeperDataInitialState: State = { nome: '', email: '', telefone: '' };

export const shopkeeperDataReducer = (state: State, action: Action): State => {
	switch (action.type) {
		case 'SET_FIELD_VALUE':
			let valor = action.payload;

			if (action.field === 'telefone') {
				valor = formataTelefone(action.payload);
			}

			return {
				...state,
				[action.field]: valor,
			};
		case 'REPLACE_STATE':
			return {
				...action.payload,
				telefone: formataTelefone(action.payload.telefone),
			};
		default:
			return state;
	}
};
